<button
  *ngIf="discussion.voted !== null"
  type="button"
  class="btn btn-sm"
  [ngClass]="{
    disabled: isSubmitting,
    'btn-outline-danger': !discussion.voted.downVote,
    'btn-danger': discussion.voted.downVote
  }"
  (click)="toggleDownvote()"
  placement="right"
  ngbTooltip="Vote discussion as not useful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-down"></i>
    <span>{{ discussion.downVoteCount }}</span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>

<button
  *ngIf="discussion.voted === null"
  type="button"
  class="btn btn-sm btn-outline-danger"
  [ngClass]="{ disabled: isSubmitting }"
  (click)="toggleDownvote()"
  placement="right"
  ngbTooltip="Vote discussion as not useful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-down"></i>
    <span>{{ discussion.downVoteCount }}</span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>
